import React, { useState, MouseEvent } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ErrorBoundary from './ErrorBoundary';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Divider,
  Collapse,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Inventory as InventoryIcon,
  Settings as SettingsIcon,
  AccountCircle,
  Logout,
  ExpandLess,
  ExpandMore,
  CalendarToday,
  Schedule,
  Article,
  Search,
  LocalHospital,
  Mail,
  LocalOffer,
  ContactMail,
  EmailOutlined,
  NotificationsActive,
  DocumentScanner,
} from '@mui/icons-material';

const drawerWidth = 280;

interface SubMenuItem {
  text: string;
  path: string;
}

interface MenuItem {
  text: string;
  icon: React.ReactElement;
  path: string;
  subItems?: SubMenuItem[];
}

const menuItems: MenuItem[] = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
  {
    text: 'Bookings Management',
    icon: <CalendarToday />,
    path: '/bookings',
    // subItems: [
    //   { text: 'All Bookings', path: '/bookings' },
    //   // { text: 'Pending Requests', path: '/bookings/pending' },
    //   // { text: 'Approved Bookings', path: '/bookings/approved' },
    //   // { text: 'Cancelled Bookings', path: '/bookings/cancelled' },
    // ],
  },
  {
    text: 'User Management',
    icon: <PeopleIcon />,
    path: '/users',
    // subItems: [
    //   { text: 'All Users', path: '/users' },
    //   { text: 'Add User', path: '/users/add' },
    //   // { text: 'Patient Data', path: '/users/patients' },
    // ],
  },
  {
    text: 'Service Management',
    icon: <InventoryIcon />,
    path: '/services',
    // subItems: [
    //   { text: 'All Services', path: '/services' },
    //   { text: 'Add Service', path: '/services/add' },
    // ],
  },
  {
    text: 'Diagnostic Centers',
    icon: <LocalHospital />,
    path: '/diagnostic-centers',
    // subItems: [
    //   { text: 'All Centers', path: '/diagnostic-centers' },
    //   { text: 'Add Center', path: '/diagnostic-centers/add' },
    // ],
  },
  {
    text: 'Content Management',
    icon: <Article />,
    path: '/content',
    // subItems: [
    //   { text: 'All Content', path: '/content' },
    //   { text: 'Add Content', path: '/content/add' },
    // ],
  },
  {
    text: 'Slot Management',
    icon: <Schedule />,
    path: '/slots',
    // subItems: [
    //   { text: 'Slots', path: '/slots' },
    //   { text: 'Add Slots', path: '/slots/add' },
    //   // { text: 'Holidays', path: '/slots/holidays' },
    // ],
  },
  {
    text: 'Promo Codes',
    icon: <LocalOffer />,
    path: '/promo-codes',
    // subItems: [
    //   { text: 'All Promo Codes', path: '/promo-codes' },
    // { text: 'Create Promo Code', path: '/promo-codes/create' },
    // { text: 'Usage Analytics', path: '/promo-codes/analytics' },
    // ],
  },
  // {
  //   text: 'Reports & Delivery',
  //   icon: <Upload />,
  //   path: '/reports',
  //   subItems: [
  //     { text: 'Upload Reports', path: '/reports/upload' },
  //     { text: 'Sent Reports', path: '/reports/sent' },
  //     // { text: 'Email Templates', path: '/reports/templates' },
  //   ],
  // },
  // {
  //   text: 'Content Management',
  //   icon: <Description />,
  //   path: '/content',
  //   subItems: [
  //     { text: 'Home Page', path: '/content/home' },
  //     // { text: 'About Page', path: '/content/about' },
  //     // { text: 'Contact Page', path: '/content/contact' },
  //     // { text: 'Policies', path: '/content/policies' },
  //   ],
  // },
  {
    text: 'SEO Management',
    icon: <Search />,
    path: '/seo',
    // subItems: [
    //   { text: 'Meta Tags', path: '/seo' },
    //   { text: 'Add Meta Tag', path: '/seo/add' },
    //   // { text: 'Google Search Console', path: '/seo/console' },
    //   // { text: 'Sitemap', path: '/seo/sitemap' },
    // ],
  },
  {
    text: 'Contact Management',
    icon: <ContactMail />,
    path: '/contact-us',
    // subItems: [{ text: 'Contact Us', path: '/contact-us' }],
  },
  // {
  //   text: 'Newsletter',
  //   icon: <Mail />,
  //   path: '/newsletter',
  // },
  {
    text: 'Notification Logs',
    icon: <NotificationsActive />,
    path: '/notification-logs',
  },
  {
    text: 'Radio Report Parser',
    icon: <DocumentScanner />,
    path: '/radio-report-parser',
  },
  // {
  //   text: 'Statistics & Export',
  //   icon: <Assessment />,
  //   path: '/statistics',
  //   subItems: [
  //     { text: 'Monthly Reports', path: '/statistics/monthly' },
  //     { text: 'Export Data', path: '/statistics/export' },
  //     { text: 'Analytics', path: '/statistics/analytics' },
  //   ],
  // },
  {
    text: 'Email Templates',
    icon: <EmailOutlined />,
    path: '/email-templates',
  },
  {
    text: 'SMTP Settings',
    icon: <Mail />,
    path: '/smtp',
  },
  { text: 'Settings', icon: <SettingsIcon />, path: '/settings' },
];

const AdminLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [expandedItems, setExpandedItems] = useState<Record<string, boolean>>(
    {}
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logout();
    navigate('/login');
  };

  const handleExpandClick = (itemText: string) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemText]: !prev[itemText],
    }));
  };

  const isItemActive = (item: MenuItem): boolean => {
    if (item.subItems) {
      return item.subItems.some(subItem => location.pathname === subItem.path);
    }
    return location.pathname === item.path;
  };

  const renderMenuItem = (item: MenuItem, level: number = 0) => {
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const isExpanded = expandedItems[item.text];
    const isActive = isItemActive(item);

    return (
      <React.Fragment key={item.text}>
        <ListItem disablePadding sx={{ mb: 0.5 }}>
          <ListItemButton
            selected={isActive}
            onClick={() => {
              if (hasSubItems) {
                handleExpandClick(item.text);
              } else {
                navigate(item.path);
              }
            }}
            sx={{
              borderRadius: 2,
              mb: 0.5,
              pl: level * 2 + 2,
              '&.Mui-selected': {
                background:
                  'linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(236, 72, 153, 0.1))',
                '&:hover': {
                  background:
                    'linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(236, 72, 153, 0.15))',
                },
                '& .MuiListItemIcon-root': {
                  color: 'primary.main',
                },
                '& .MuiListItemText-primary': {
                  color: 'primary.main',
                  fontWeight: 600,
                },
              },
              '&:hover': {
                background: 'rgba(99, 102, 241, 0.05)',
                borderRadius: 2,
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                fontWeight: isActive ? 600 : 500,
                fontSize: level > 0 ? '0.875rem' : '0.9rem',
              }}
            />
            {hasSubItems && (isExpanded ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </ListItem>
        {hasSubItems && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.subItems!.map(subItem => (
                <ListItem key={subItem.text} disablePadding sx={{ mb: 0.5 }}>
                  <ListItemButton
                    selected={location.pathname === subItem.path}
                    onClick={() => navigate(subItem.path)}
                    sx={{
                      borderRadius: 2,
                      mb: 0.5,
                      pl: level * 2 + 4,
                      '&.Mui-selected': {
                        background:
                          'linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(236, 72, 153, 0.1))',
                        '&:hover': {
                          background:
                            'linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(236, 72, 153, 0.15))',
                        },
                        '& .MuiListItemText-primary': {
                          color: 'primary.main',
                          fontWeight: 600,
                        },
                      },
                      '&:hover': {
                        background: 'rgba(99, 102, 241, 0.05)',
                        borderRadius: 2,
                      },
                    }}
                  >
                    <ListItemText
                      primary={subItem.text}
                      primaryTypographyProps={{
                        fontWeight:
                          location.pathname === subItem.path ? 600 : 500,
                        fontSize: '0.875rem',
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  const drawer = (
    <div>
      <Toolbar>
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              mr: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src="/images/logo/logo.svg"
              alt="Clear Scan Logo"
              style={{
                height: 'auto',
                width: 'auto',
                maxWidth: '180px',
                padding: '12px',
                // background: '#000000',
              }}
            />
          </Box>
          {/* <Typography variant="h6" noWrap component="div" fontWeight="bold">
            Clear Scan Admin
          </Typography> */}
        </Box>
      </Toolbar>
      <Divider />
      <List sx={{ px: 2 }}>{menuItems.map(item => renderMenuItem(item))}</List>
    </div>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          background: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
          color: 'text.primary',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1 }}
            fontWeight="bold"
          >
            {/* {menuItems.find(
              item =>
                item.path === location.pathname ||
                (item.subItems &&
                  item.subItems.some(
                    subItem => subItem.path === location.pathname
                  ))
            )?.text || 'Dashboard'} */}
          </Typography>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            sx={{
              bgcolor: 'primary.main',
              color: 'white',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
            }}
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                navigate('/profile');
              }}
            >
              <ListItemIcon>
                <AccountCircle fontSize="small" />
              </ListItemIcon>
              Profile
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {/* Keyed by pathname so navigating to a different page resets the
            boundary - otherwise, once one page crashed, every subsequent
            page would keep showing the same stale fallback instead of
            actually rendering. */}
        <ErrorBoundary
          key={location.pathname}
          fallbackDescription="This page ran into an unexpected error. Reloading usually fixes it, or use the sidebar to go to a different page."
        >
          <Outlet />
        </ErrorBoundary>
      </Box>
    </Box>
  );
};

export default AdminLayout;
